import React, { useCallback, useState } from 'react'
import context from '@/context'
import { ModalBody, Form, FormGroup, Label, Row, Col } from 'reactstrap'
import Resx from '@/components/Resx'
import { DropDownList } from '@/components/dropDownList'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { intMaxValue } from '@/utils/constants'

const OutputReportGroupDefinitionPermissionsDialog = React.memo(function OutputReportGroupDefinitionPermissionsDialog ({ outputReportGroupDefinition, onAction, dataIndex, ...props }) {
  const { id, jobPositionAssignmentId } = outputReportGroupDefinition

  const [item, setItem] = useState(outputReportGroupDefinition.outputReportGroupDefinition || null)

  const outputReportGroupDefinitionChange = useCallback((e) => setItem(e.item), [])

  const onSave = useCallback(() => {
    onAction({
      item: {
        id,
        jobPositionAssignmentId,
        outputReportGroupDefinition: item
      },
      dataIndex
    })
  }, [onAction, id, jobPositionAssignmentId, item, dataIndex])

  const outputReportDefinitionDataSource = useCallback((req) => context.api.outputReportGroupDefinitionService.getLookup(req), [])
  return (
    <ValidationBoundary>
      <BasicHeader title='Permissions.OutputReportGroupDefinition' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Form>
            <Row>
              <Col>
                <FormGroup>
                  <Label><Resx name='Permissions.OutputReportGroupDefinition' /></Label>
                  <Validator name='outputReportGroupDefinition' value={item} required>
                    <DropDownList name='outputReportGroupDefinition'
                      dataSource={outputReportDefinitionDataSource}
                      onChange={outputReportGroupDefinitionChange}
                      value={item}
                    />
                  </Validator>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText='Common.Save' icon='save' {...props} onAction={onSave} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
})

export const maxInt = intMaxValue

export function getInstitutionPermissions (targetId, data) {
  return !targetId ? maxInt : data.getIn(['modifiedData', 'permissions'])
}

export default {
  modalProps: {
    size: 'lg'
  },
  component: OutputReportGroupDefinitionPermissionsDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/outputReportGroupDefinitionPermissions.js